import React from 'react';
import './Modal.css';

const Modal = ({ show, handleClose, children }) => {
  const showHideClassName = show ? "modal display-block" : "modal display-none";

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        {children}
        <button className ="bu_cl-p" onClick={handleClose}>閉じる</button>
      </section>
    </div>
  );
};

export default Modal;